import { Box, Button, ButtonProps, useMediaQuery, useTheme } from "@mui/material";
import React, { useEffect } from "react";
import { useAppDispatch } from "store";
import { setPageButton } from "store/core";

const BottomButton = (props: ButtonProps) => (
  <Button
    {...props}
    style={{ flex: "auto", borderRadius: "0px", color: "white", fontSize: "11px", fontWeight: "bold", height: "100%", ...props.style }}
  />
);

type MobileBottomContainerProps = {
  bgcolor?: string;
  children: React.ReactNode | React.ReactNode[];
};
export const MobileBottomContainer = ({
  bgcolor,
  children,
}: MobileBottomContainerProps): React.ReactElement => {
  const theme = useTheme();
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(setPageButton(true));
    return () => {
      dispatch(setPageButton(false));
    };
  }, [dispatch]);
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  return (
    <Box
      display={{ xs: "flex", sm: "none" }}
      bottom="0"
      left="0"
      width="100%"
      height="42px"
      bgcolor={bgcolor ?? theme.palette.primary.main}
      zIndex={10}
      style={isMobile ? { marginBottom: "10px" } : {}}
    >
      {children}
    </Box>
  );
};

MobileBottomContainer.Button = BottomButton;
